// This file is auto-generated by @hey-api/openapi-ts

/**
 * Action.
 */
export type Action = {
    name: string;
    title: (string | null);
    method: string;
    href: string;
    operation: (string | null);
};

/**
 * Response body for Artefact.
 */
export type Artefact = {
    identity: string;
    name: string;
    mimetype: string;
    links?: {
        [key: string]: Hateoas;
    };
};

/**
 * Response body for Artefact group with artefacts.
 */
export type ArtefactGroupWithArtefacts = {
    identity: string;
    name: string;
    artefacts: Array<(Artefact | ArtefactGroupWithArtefacts)>;
};

export type Body_start_biz_artefact_management_add_artefact_group_start_post = {
    owner_id: string;
    name: string;
    /**
     * Added {artefact.name}
     */
    commit_message?: string;
};

export type Body_start_biz_artefact_management_add_artefact_start_post = {
    owner_id: string;
    file_: (Blob | File);
    /**
     * Added {artefact.name}
     */
    commit_message?: string;
};

export type Body_start_biz_artefact_management_get_artefact_start_post = {
    artefact_id: string;
    revision?: (string | null);
};

export type Body_start_biz_artefact_management_get_artefacts_tree_start_post = {
    artefact_group_id: string;
};

export type Body_start_biz_artefact_management_get_history_start_post = {
    artefact_id: string;
    limit?: number;
    offset?: number;
};

export type Body_start_biz_artefact_management_remove_artefact_group_start_post = {
    artefact_group_id: string;
    commit_message?: string;
};

export type Body_start_biz_artefact_management_remove_artefact_start_post = {
    artefact_id: string;
    commit_message?: string;
};

export type Body_start_biz_artefact_management_rename_artefact_group_start_post = {
    artefact_group_id: string;
    name: string;
    commit_message?: string;
};

export type Body_start_biz_artefact_management_rename_artefact_start_post = {
    artefact_id: string;
    name: string;
    commit_message?: string;
};

export type Body_start_biz_artefact_management_restore_historical_artefact_start_post = {
    artefact_id: string;
    revision: string;
    commit_message?: string;
};

export type Body_start_biz_artefact_management_update_artefact_content_start_post = {
    artefact_id: string;
    file_: (Blob | File);
    /**
     * Added {artefact.name}
     */
    commit_message?: string;
};

export type Body_start_biz_artefact_management_update_artefact_start_post = {
    artefact_id: string;
    name?: (string | null);
    content?: ((Blob | File) | null);
    /**
     * Added {artefact.name}
     */
    commit_message?: string;
};

export type Body_start_biz_entities__entity_type___entity_id___attribute__restore_post = {
    revision: string;
};

export type Body_start_dashboard_dashboard_mgt_update_dashboard_start_post = {
    dashboard_id: string;
    widgets: Array<Widget>;
};

export type Body_start_domain_business_entity_mgt_create_business_entity_start_post = {
    domain_id: string;
    metadata: BusinessEntityMeta;
    definition: Array<BusinessEntityFieldDefinition>;
};

export type Body_start_domain_business_entity_mgt_delete_business_entity_start_post = {
    business_entity_id: string;
    domain_id: string;
};

export type Body_start_domain_business_entity_mgt_get_business_entities_by_domain_start_post = {
    domain_id: string;
};

export type Body_start_domain_business_entity_mgt_get_business_entity_start_post = {
    business_entity_id: string;
    domain_id: string;
};

export type Body_start_domain_business_entity_mgt_update_business_entity_start_post = {
    business_entity_id: string;
    metadata: BusinessEntityMeta;
    definition: (Array<BusinessEntityFieldDefinition> | null);
    domain_id: string;
};

export type Body_start_domain_domain_mgt_create_domain_start_post = {
    name: string;
    description?: ((Blob | File) | null);
};

export type Body_start_domain_domain_mgt_delete_domain_start_post = {
    domain_id: string;
};

export type Body_start_domain_domain_mgt_get_domain_start_post = {
    domain_id: string;
    revision?: (string | null);
};

export type Body_start_domain_domain_mgt_update_domain_start_post = {
    domain_id: string;
    name?: (string | null);
    description?: ((Blob | File) | null);
};

export type Body_start_domain_label_mgt_create_label_start_post = {
    label: Label;
    domain_id: string;
};

export type Body_start_domain_label_mgt_get_labels_by_domain_start_post = {
    domain_id: string;
};

export type Body_start_domain_label_mgt_get_labels_by_topic_start_post = {
    topic: Topic;
    domain_id: string;
};

export type Body_start_domain_label_mgt_label_topic_start_post = {
    label: Label;
    topic: Topic;
    domain_id: string;
};

export type Body_start_domain_label_mgt_unlabel_topic_start_post = {
    label: Label;
    topic: Topic;
    domain_id: string;
};

export type Body_start_domain_role_mgt_create_role_start_post = {
    domain_id: string;
    name: string;
    description?: ((Blob | File) | null);
};

export type Body_start_domain_role_mgt_delete_role_start_post = {
    role_id: string;
};

export type Body_start_domain_role_mgt_get_role_start_post = {
    role_id: string;
    revision?: (string | null);
};

export type Body_start_domain_role_mgt_get_roles_start_post = {
    domain_id: string;
};

export type Body_start_domain_role_mgt_update_role_start_post = {
    role_id: string;
    name?: (string | null);
    description?: ((Blob | File) | null);
};

export type Body_start_domain_topic_mgt_create_reply_start_post = {
    reply: Reply;
    topic: Topic;
    domain: Domain_Input;
};

export type Body_start_domain_topic_mgt_create_topic_start_post = {
    domain: Domain_Input;
    topic: TopicCreate;
};

export type Body_start_domain_topic_mgt_get_replies_on_topic_start_post = {
    topic_title: string;
    domain: Domain_Input;
};

export type Body_start_domain_topic_mgt_get_topic_start_post = {
    topic_title: string;
    domain: Domain_Input;
};

export type Body_start_domain_topic_mgt_get_topics_by_domain_start_post = {
    domain_id: DomainIdSchema;
};

export type Body_start_domain_topic_mgt_update_topic_start_post = {
    domain: Domain_Input;
    topic: TopicCreate;
};

export type Body_start_process_lane_mgt_get_lane_by_bpmn_id_start_post = {
    process_id: string;
    bpmn_id: string;
    lane_id: string;
};

export type Body_start_process_lane_mgt_get_lane_by_role_id_start_post = {
    process_id: string;
    role_id: string;
    lane_id: string;
};

export type Body_start_process_lane_mgt_get_lane_start_post = {
    lane_id: string;
};

export type Body_start_process_lane_mgt_get_lanes_by_process_start_post = {
    process_id: string;
};

export type Body_start_process_process_element_mgt_archive_process_element_start_post = {
    task_id: string;
};

export type Body_start_process_process_element_mgt_delete_event_start_post = {
    event_id: string;
};

export type Body_start_process_process_element_mgt_delete_flow_start_post = {
    flow_id: string;
};

export type Body_start_process_process_element_mgt_delete_gateway_start_post = {
    gateway_id: string;
};

export type Body_start_process_process_element_mgt_delete_task_start_post = {
    task_id: string;
};

export type Body_start_process_process_element_mgt_get_event_start_post = {
    event_id: string;
    revision?: (string | null);
    include_archived?: boolean;
};

export type Body_start_process_process_element_mgt_get_flow_start_post = {
    flow_id: string;
    revision?: (string | null);
    include_archived?: boolean;
};

export type Body_start_process_process_element_mgt_get_gateway_start_post = {
    gateway_id: string;
    revision?: (string | null);
    include_archived?: boolean;
};

export type Body_start_process_process_element_mgt_get_process_element_by_bpmn_id_start_post = {
    process_id: string;
    bpmn_id: string;
    include_archived?: boolean;
    task_id: string;
};

export type Body_start_process_process_element_mgt_get_process_elements_by_process_start_post = {
    process_id: string;
    include_archived?: boolean;
};

export type Body_start_process_process_element_mgt_get_task_start_post = {
    task_id: string;
    revision?: (string | null);
    include_archived?: boolean;
};

export type Body_start_process_process_element_mgt_unarchive_process_element_start_post = {
    process_element_id: string;
    task_id: string;
};

export type Body_start_process_process_element_mgt_update_event_start_post = {
    event_id: string;
    bpmn_id?: (string | null);
    name?: (string | null);
    description?: ((Blob | File) | null);
};

export type Body_start_process_process_element_mgt_update_flow_start_post = {
    flow_id: string;
    bpmn_id?: (string | null);
    name?: (string | null);
    description?: ((Blob | File) | null);
};

export type Body_start_process_process_element_mgt_update_gateway_start_post = {
    gateway_id: string;
    bpmn_id?: (string | null);
    name?: (string | null);
    description?: ((Blob | File) | null);
};

export type Body_start_process_process_element_mgt_update_task_start_post = {
    task_id: string;
    bpmn_id?: (string | null);
    name?: (string | null);
    description?: ((Blob | File) | null);
};

export type Body_start_process_process_mgt_create_process_start_post = {
    product_id: string;
    name: string;
    description?: ((Blob | File) | null);
    process_definition?: ((Blob | File) | null);
};

export type Body_start_process_process_mgt_delete_process_start_post = {
    process_id: string;
};

export type Body_start_process_process_mgt_deploy_process_start_post = {
    process_id: string;
    definition_path: string;
};

export type Body_start_process_process_mgt_generate_definition_start_post = {
    prompt: string;
    process_id: string;
};

export type Body_start_process_process_mgt_get_process_start_post = {
    process_id: string;
    revision?: (string | null);
};

export type Body_start_process_process_mgt_get_processes_by_product_start_post = {
    product_id: string;
};

export type Body_start_process_process_mgt_move_process_start_post = {
    process_id: string;
    target_product_id: string;
};

export type Body_start_process_process_mgt_update_process_start_post = {
    process_id: string;
    name?: (string | null);
    description?: ((Blob | File) | null);
    process_definition?: ((Blob | File) | null);
};

export type Body_start_product_product_mgt_create_product_start_post = {
    domain_id: string;
    name: string;
    description?: ((Blob | File) | null);
};

export type Body_start_product_product_mgt_delete_product_start_post = {
    product_id: string;
};

export type Body_start_product_product_mgt_get_product_start_post = {
    product_id: string;
    revision?: (string | null);
};

export type Body_start_product_product_mgt_get_products_by_domain_start_post = {
    domain_id: string;
};

export type Body_start_product_product_mgt_update_product_start_post = {
    product_id: string;
    name?: (string | null);
    description?: ((Blob | File) | null);
};

export type Body_start_stek_stek_mgt_create_stek_start_post = {
    name: string;
};

export type Body_start_workspace_worktree_mgt_get_worktree_start_post = {
    workspace_id: string;
};

/**
 * Business entity response.
 */
export type BusinessEntity = {
    domain_id: string;
    identity: string;
    metadata: BusinessEntityMeta;
    definition?: Array<BusinessEntityFieldDefinition>;
};

/**
 * Definition of a business entity field
 */
export type BusinessEntityFieldDefinition = {
    name: string;
    type: BusinessEntityFieldType;
    title?: (string | null);
    description?: (string | null);
};

/**
 * Field type
 */
export enum BusinessEntityFieldType {
    STRING = 'string',
    NUMBER = 'number',
    INTEGER = 'integer',
    BOOLEAN = 'boolean'
}

/**
 * Business entity response without the definition.
 */
export type BusinessEntityMeta = {
    name: string;
    description?: (string | null);
};

/**
 * Request body for chatbot prompts
 */
export type ChatbotPrompt = {
    context: string;
    history: Array<Message>;
    prompt: string;
};

/**
 * The role of the user across the organization.
 */
export enum ClusterRole {
    USER = 'user',
    USER_MANAGER = 'user-manager'
}

/**
 * An author or committer of a HistoryEntry.
 */
export type Contributor = {
    name: string;
    email: string;
    date: string;
};

/**
 * Function to create a connection between two elements.
 */
export type CreateConnection = {
    name?: 'createConnection';
    label: string;
    source: string;
    target: string;
};

export enum name {
    CREATE_CONNECTION = 'createConnection'
}

/**
 * Function to create a connection between two elements.
 */
export type CreateEntity = {
    name: string;
    type: string;
    description: string;
};

export type CreateGateway = {
    previous_element: string;
    label: string;
    connection_label: string;
    name?: 'createGateway';
};

export enum name2 {
    CREATE_GATEWAY = 'createGateway'
}

export type CreateTask = {
    previous_element: string;
    label: string;
    connection_label: string;
    name?: 'createTask';
    role: string;
};

export enum name3 {
    CREATE_TASK = 'createTask'
}

/**
 * Create a new user.
 */
export type CreateUser = {
    email: string;
    name: string;
};

/**
 * Dashboard within MyStekz.
 */
export type Dashboard = {
    identity: string;
    name: string;
    widgets?: Array<Widget>;
};

/**
 * Request body for Domain.
 */
export type Domain_Input = {
    identity: string;
    name: string;
    short_description?: (string | null);
    user_artefact_group_id?: (string | null);
    description?: (Artefact | null);
};

/**
 * Request body for Domain.
 */
export type Domain_Output = {
    identity: string;
    name: string;
    short_description?: (string | null);
    user_artefact_group_id?: (string | null);
    description?: (Artefact | null);
};

export type DomainIdSchema = {
    name: string;
};

/**
 * Domain representation inside worktree, does not describe Domain.
 */
export type DomainInTree = {
    identity: string;
    user_artefact_group_id?: (string | null);
    name: string;
    short_description?: (string | null);
    products: Array<ProductInTree>;
};

/**
 * The domain roles in relation to the user.
 */
export type DomainRole = {
    role_name: string;
    domain_name: string;
    authorized: boolean;
};

/**
 * Entity information.
 */
export type EntityInfo = {
    identity: string;
    entity_type: EntityType;
    user_artefact_group_id?: (string | null);
    name: string;
    short_description?: (string | null);
    parent?: (EntityInfo | null);
};

export enum EntityType {
    ORGANIZATION = 'organization',
    STEK = 'stek',
    DOMAIN = 'domain',
    PRODUCT = 'product',
    ROLE = 'role',
    PROCESS = 'process',
    TASK = 'task',
    GATEWAY = 'gateway',
    EVENT = 'event',
    FLOW = 'flow',
    ARTEFACT = 'artefact',
    ARTEFACT_GROUP = 'artefact_group',
    BUSINESS_ENTITY = 'business_entity',
    DOCUMENT = 'document'
}

/**
 * Response body for Hoteos.
 */
export type Hateoas = {
    href: string;
    type: string;
};

/**
 * A value object which represents a point in time of the artefact.
 */
export type HistoryEntry = {
    id: string;
    subject: string;
    body: string;
    author: Contributor;
    committer: Contributor;
};

export type HTTPValidationError = {
    detail?: Array<ValidationError>;
};

/**
 * Labels are used to categorize topics
 *
 * A label is unique for the combination of domain and title (composite key)
 * repo is e.g. com_stekz/steks/mystekz/biz/main
 */
export type Label = {
    title: string;
    description: (string | null);
    color: (string | null);
};

/**
 * Request body for Lane.
 */
export type Lane = {
    identity: string;
    bpmn_id: string;
    name: string;
    role_id?: (string | null);
};

export type LinkPreview = {
    title?: (string | null);
    description?: (string | null);
    image?: (string | null);
    domain?: (string | null);
};

export type Message = {
    role: 'system' | 'user' | 'assistant';
    content: string;
};

export enum role {
    SYSTEM = 'system',
    USER = 'user',
    ASSISTANT = 'assistant'
}

/**
 * Organization within MyStekz.
 */
export type Organization = {
    identity: string;
    name: string;
    parent_id?: (string | null);
};

/**
 * Request body for Product.
 */
export type Process = {
    identity: string;
    name: string;
    user_artefact_group_id?: (string | null);
    description?: (Artefact | null);
    process_definition?: (Artefact | null);
    short_description?: (string | null);
};

/**
 * Request body for Task.
 */
export type ProcessElement = {
    identity: string;
    bpmn_id: string;
    name: string;
    user_artefact_group_id?: (string | null);
    description?: (Artefact | null);
    is_archived?: boolean;
    archived_at?: (Date | null);
    short_description?: (string | null);
    type: ProcessElementType;
    subtype?: (string | null);
};

export enum ProcessElementType {
    TASK = 'task',
    GATEWAY = 'gateway',
    EVENT = 'event',
    FLOW = 'flow'
}

export type ProcessEvent = {
    identity: string;
    bpmn_id: string;
    name: string;
    user_artefact_group_id?: (string | null);
    description?: (Artefact | null);
    is_archived?: boolean;
    archived_at?: (Date | null);
    short_description?: (string | null);
    type?: ProcessElementType;
    subtype?: (string | null);
};

export type ProcessFlow = {
    identity: string;
    bpmn_id: string;
    name: string;
    user_artefact_group_id?: (string | null);
    description?: (Artefact | null);
    is_archived?: boolean;
    archived_at?: (Date | null);
    short_description?: (string | null);
    type?: ProcessElementType;
    subtype?: (string | null);
};

export type ProcessGateway = {
    identity: string;
    bpmn_id: string;
    name: string;
    user_artefact_group_id?: (string | null);
    description?: (Artefact | null);
    is_archived?: boolean;
    archived_at?: (Date | null);
    short_description?: (string | null);
    type?: ProcessElementType;
    subtype?: (string | null);
};

/**
 * Process representation inside worktree, does not describe Process.
 */
export type ProcessInTree = {
    identity: string;
    user_artefact_group_id?: (string | null);
    name: string;
    short_description?: (string | null);
};

export type ProcessTask = {
    identity: string;
    bpmn_id: string;
    name: string;
    user_artefact_group_id?: (string | null);
    description?: (Artefact | null);
    is_archived?: boolean;
    archived_at?: (Date | null);
    short_description?: (string | null);
    type?: ProcessElementType;
    subtype?: (string | null);
};

/**
 * Request body for Product.
 */
export type Product = {
    identity: string;
    name: string;
    user_artefact_group_id?: (string | null);
    description?: (Artefact | null);
};

/**
 * Product representation inside worktree, does not describe Product.
 */
export type ProductInTree = {
    identity: string;
    user_artefact_group_id?: (string | null);
    name: string;
    short_description?: (string | null);
    processes: Array<ProcessInTree>;
};

/**
 * Request body for adding a public SSH key.
 */
export type PublicKey = {
    pubkey: string;
};

/**
 * Replies are conversations on a topic.
 */
export type Reply = {
    body: string;
    modified: (string | null);
    created: (string | null);
};

/**
 * Request body for Role.
 */
export type Role = {
    identity: string;
    name: string;
    short_description?: (string | null);
    user_artefact_group_id?: (string | null);
    description?: (Artefact | null);
};

/**
 * Request body for Stek.
 */
export type Stek = {
    identity: string;
    name: string;
};

/**
 * Topics are the center of discucsions and comments
 */
export type Topic = {
    title: string;
};

/**
 * Schema for creating a Topic.
 */
export type TopicCreate = {
    title: string;
    body: string;
};

/**
 * Response schema a Topic.
 */
export type TopicResponse = {
    title: string;
    body: string;
    created: (string | null);
    modified: (string | null);
    author: (string | null);
};

/**
 * User model.
 */
export type User = {
    identity: string;
    email: string;
    role: ClusterRole;
    name: string;
    _actions?: Array<Action>;
};

export type ValidationError = {
    loc: Array<(string | number)>;
    msg: string;
    type: string;
};

/**
 * Widget within a Dashboard.
 */
export type Widget = {
    x: number;
    y: number;
    w: number;
    h: number;
    content: string;
};

/**
 * A worktree represents the hierarchy of a system, described in terms of
 * domains, products and processes. It can be used to render a tree view of
 * the system.
 *
 * Note, the schema does not expose the branch that is used across all
 * entities (stek and its domains), unlike the domain entity.
 */
export type Worktree = {
    stek_id: string;
    domains: Array<DomainInTree>;
};

export type StartOrganizationUserMgtAddPublicKeyStartPostData = {
    body: PublicKey;
    query: {
        keyname: string;
    };
};

export type StartOrganizationUserMgtAddPublicKeyStartPostResponse = ({
    [key: string]: Array<PublicKey>;
});

export type StartOrganizationUserMgtAddPublicKeyStartPostError = (HTTPValidationError);

export type StartOrganizationUserMgtGetPublicKeysStartPostResponse = ({
    [key: string]: Array<PublicKey>;
});

export type StartOrganizationUserMgtGetPublicKeysStartPostError = unknown;

export type StartOrganizationOrganizationMgtGetOrganizationsStartPostResponse = (Array<Organization>);

export type StartOrganizationOrganizationMgtGetOrganizationsStartPostError = unknown;

export type StartOrganizationOrganizationMgtGetOrganizationByNameStartPostData = {
    query: {
        name: string;
    };
};

export type StartOrganizationOrganizationMgtGetOrganizationByNameStartPostResponse = (Organization);

export type StartOrganizationOrganizationMgtGetOrganizationByNameStartPostError = (HTTPValidationError);

export type StartBizArtefactManagementAddArtefactGroupStartPostData = {
    body: Body_start_biz_artefact_management_add_artefact_group_start_post;
};

export type StartBizArtefactManagementAddArtefactGroupStartPostResponse = (unknown);

export type StartBizArtefactManagementAddArtefactGroupStartPostError = (HTTPValidationError);

export type StartBizArtefactManagementRemoveArtefactGroupStartPostData = {
    body: Body_start_biz_artefact_management_remove_artefact_group_start_post;
};

export type StartBizArtefactManagementRemoveArtefactGroupStartPostResponse = (unknown);

export type StartBizArtefactManagementRemoveArtefactGroupStartPostError = (HTTPValidationError);

export type StartBizArtefactManagementUpdateArtefactStartPostData = {
    body: Body_start_biz_artefact_management_update_artefact_start_post;
};

export type StartBizArtefactManagementUpdateArtefactStartPostResponse = (unknown);

export type StartBizArtefactManagementUpdateArtefactStartPostError = (HTTPValidationError);

export type StartBizArtefactManagementAddArtefactStartPostData = {
    body: Body_start_biz_artefact_management_add_artefact_start_post;
};

export type StartBizArtefactManagementAddArtefactStartPostResponse = (Artefact);

export type StartBizArtefactManagementAddArtefactStartPostError = (HTTPValidationError);

export type StartBizArtefactManagementGetArtefactsTreeStartPostData = {
    body: Body_start_biz_artefact_management_get_artefacts_tree_start_post;
};

export type StartBizArtefactManagementGetArtefactsTreeStartPostResponse = (Array<(Artefact | ArtefactGroupWithArtefacts)>);

export type StartBizArtefactManagementGetArtefactsTreeStartPostError = (HTTPValidationError);

export type StartBizArtefactManagementRemoveArtefactStartPostData = {
    body: Body_start_biz_artefact_management_remove_artefact_start_post;
};

export type StartBizArtefactManagementRemoveArtefactStartPostResponse = (unknown);

export type StartBizArtefactManagementRemoveArtefactStartPostError = (HTTPValidationError);

export type StartBizArtefactManagementGetHistoryStartPostData = {
    body: Body_start_biz_artefact_management_get_history_start_post;
};

export type StartBizArtefactManagementGetHistoryStartPostResponse = ({
    [key: string]: Array<HistoryEntry>;
});

export type StartBizArtefactManagementGetHistoryStartPostError = (HTTPValidationError);

export type StartBizArtefactManagementRenameArtefactGroupStartPostData = {
    body: Body_start_biz_artefact_management_rename_artefact_group_start_post;
};

export type StartBizArtefactManagementRenameArtefactGroupStartPostResponse = (unknown);

export type StartBizArtefactManagementRenameArtefactGroupStartPostError = (HTTPValidationError);

export type StartBizArtefactManagementGetArtefactStartPostData = {
    body: Body_start_biz_artefact_management_get_artefact_start_post;
};

export type StartBizArtefactManagementGetArtefactStartPostResponse = (unknown);

export type StartBizArtefactManagementGetArtefactStartPostError = (HTTPValidationError);

export type StartBizArtefactManagementRestoreHistoricalArtefactStartPostData = {
    body: Body_start_biz_artefact_management_restore_historical_artefact_start_post;
};

export type StartBizArtefactManagementRestoreHistoricalArtefactStartPostResponse = (unknown);

export type StartBizArtefactManagementRestoreHistoricalArtefactStartPostError = (HTTPValidationError);

export type StartBizArtefactManagementRenameArtefactStartPostData = {
    body: Body_start_biz_artefact_management_rename_artefact_start_post;
};

export type StartBizArtefactManagementRenameArtefactStartPostResponse = (unknown);

export type StartBizArtefactManagementRenameArtefactStartPostError = (HTTPValidationError);

export type StartBizArtefactManagementUpdateArtefactContentStartPostData = {
    body: Body_start_biz_artefact_management_update_artefact_content_start_post;
};

export type StartBizArtefactManagementUpdateArtefactContentStartPostResponse = (unknown);

export type StartBizArtefactManagementUpdateArtefactContentStartPostError = (HTTPValidationError);

export type StartBizEntitiesEntityTypeEntityIdInfoGetData = {
    path: {
        entity_id: string;
        entity_type: EntityType;
    };
};

export type StartBizEntitiesEntityTypeEntityIdInfoGetResponse = (EntityInfo);

export type StartBizEntitiesEntityTypeEntityIdInfoGetError = (HTTPValidationError);

export type StartBizEntitiesEntityTypeEntityIdAttributeGetData = {
    path: {
        attribute: string;
        entity_id: string;
        entity_type: string;
    };
    query?: {
        revision?: (string | null);
    };
};

export type StartBizEntitiesEntityTypeEntityIdAttributeGetResponse = (unknown);

export type StartBizEntitiesEntityTypeEntityIdAttributeGetError = (HTTPValidationError);

export type StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetData = {
    path: {
        attribute: string;
        entity_id: string;
        entity_type: string;
    };
    query?: {
        limit?: number;
        offset?: number;
    };
};

export type StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetResponse = ({
    [key: string]: Array<HistoryEntry>;
});

export type StartBizEntitiesEntityTypeEntityIdAttributeHistoryGetError = (HTTPValidationError);

export type StartBizEntitiesEntityTypeEntityIdAttributeRestorePostData = {
    body: Body_start_biz_entities__entity_type___entity_id___attribute__restore_post;
    path: {
        attribute: string;
        entity_id: string;
        entity_type: string;
    };
};

export type StartBizEntitiesEntityTypeEntityIdAttributeRestorePostResponse = (unknown);

export type StartBizEntitiesEntityTypeEntityIdAttributeRestorePostError = (HTTPValidationError);

export type StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostData = {
    path: {
        entity_id: string;
        entity_type: string;
    };
};

export type StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostResponse = (string);

export type StartBizEntitiesEntityTypeEntityIdGenerateDescriptionPostError = (HTTPValidationError);

export type StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostData = {
    path: {
        entity_id: string;
        entity_type: string;
    };
};

export type StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostResponse = (Array<CreateEntity>);

export type StartBizEntitiesEntityTypeEntityIdGenerateChildrenPostError = (HTTPValidationError);

export type StartWorkspaceWorktreeMgtGetWorktreeStartPostData = {
    body: Body_start_workspace_worktree_mgt_get_worktree_start_post;
};

export type StartWorkspaceWorktreeMgtGetWorktreeStartPostResponse = (Worktree);

export type StartWorkspaceWorktreeMgtGetWorktreeStartPostError = (HTTPValidationError);

export type StartStekStekMgtTreeStartPostData = {
    body?: (string | null);
};

export type StartStekStekMgtTreeStartPostResponse = (unknown);

export type StartStekStekMgtTreeStartPostError = (HTTPValidationError);

export type StartStekStekMgtUpdateStekConfigurationsStartPostData = {
    body: {
        [key: string]: unknown;
    };
};

export type StartStekStekMgtUpdateStekConfigurationsStartPostResponse = ({
    [key: string]: unknown;
});

export type StartStekStekMgtUpdateStekConfigurationsStartPostError = (HTTPValidationError);

export type StartStekStekMgtGetSteksByOrganizationStartPostResponse = (Array<Stek>);

export type StartStekStekMgtGetSteksByOrganizationStartPostError = unknown;

export type StartStekStekMgtCreateStekStartPostData = {
    body: Body_start_stek_stek_mgt_create_stek_start_post;
};

export type StartStekStekMgtCreateStekStartPostResponse = (unknown);

export type StartStekStekMgtCreateStekStartPostError = (HTTPValidationError);

export type StartStekStekMgtGetStekConfigurationsStartPostResponse = ({
    [key: string]: unknown;
});

export type StartStekStekMgtGetStekConfigurationsStartPostError = unknown;

export type StartStekStekMgtGetStekStartPostResponse = (Stek);

export type StartStekStekMgtGetStekStartPostError = unknown;

export type StartStekStekMgtDeleteStekStartPostResponse = (unknown);

export type StartStekStekMgtDeleteStekStartPostError = unknown;

export type StartAgentDocPromptStartPostData = {
    body: ChatbotPrompt;
};

export type StartAgentDocPromptStartPostResponse = (unknown);

export type StartAgentDocPromptStartPostError = (HTTPValidationError);

export type StartProductProductMgtGetProductStartPostData = {
    body: Body_start_product_product_mgt_get_product_start_post;
};

export type StartProductProductMgtGetProductStartPostResponse = (Product);

export type StartProductProductMgtGetProductStartPostError = (HTTPValidationError);

export type StartProductProductMgtUpdateProductStartPostData = {
    body: Body_start_product_product_mgt_update_product_start_post;
};

export type StartProductProductMgtUpdateProductStartPostResponse = (unknown);

export type StartProductProductMgtUpdateProductStartPostError = (HTTPValidationError);

export type StartProductProductMgtDeleteProductStartPostData = {
    body: Body_start_product_product_mgt_delete_product_start_post;
};

export type StartProductProductMgtDeleteProductStartPostResponse = (unknown);

export type StartProductProductMgtDeleteProductStartPostError = (HTTPValidationError);

export type StartProductProductMgtCreateProductStartPostData = {
    body: Body_start_product_product_mgt_create_product_start_post;
};

export type StartProductProductMgtCreateProductStartPostResponse = (Product);

export type StartProductProductMgtCreateProductStartPostError = (HTTPValidationError);

export type StartProductProductMgtGetProductsByDomainStartPostData = {
    body: Body_start_product_product_mgt_get_products_by_domain_start_post;
};

export type StartProductProductMgtGetProductsByDomainStartPostResponse = (Array<Product>);

export type StartProductProductMgtGetProductsByDomainStartPostError = (HTTPValidationError);

export type StartDashboardDashboardMgtGetDashboardsByStekStartPostResponse = (Array<Dashboard>);

export type StartDashboardDashboardMgtGetDashboardsByStekStartPostError = unknown;

export type StartDashboardDashboardMgtUpdateDashboardStartPostData = {
    body: Body_start_dashboard_dashboard_mgt_update_dashboard_start_post;
};

export type StartDashboardDashboardMgtUpdateDashboardStartPostResponse = (Dashboard);

export type StartDashboardDashboardMgtUpdateDashboardStartPostError = (HTTPValidationError);

export type StartDomainDomainMgtDeleteDomainStartPostData = {
    body: Body_start_domain_domain_mgt_delete_domain_start_post;
};

export type StartDomainDomainMgtDeleteDomainStartPostResponse = (unknown);

export type StartDomainDomainMgtDeleteDomainStartPostError = (HTTPValidationError);

export type StartDomainDomainMgtGetDomainsByStekStartPostResponse = (Array<Domain_Output>);

export type StartDomainDomainMgtGetDomainsByStekStartPostError = unknown;

export type StartDomainDomainMgtUpdateDomainStartPostData = {
    body: Body_start_domain_domain_mgt_update_domain_start_post;
};

export type StartDomainDomainMgtUpdateDomainStartPostResponse = (unknown);

export type StartDomainDomainMgtUpdateDomainStartPostError = (HTTPValidationError);

export type StartDomainDomainMgtGetDomainStartPostData = {
    body: Body_start_domain_domain_mgt_get_domain_start_post;
};

export type StartDomainDomainMgtGetDomainStartPostResponse = (Domain_Output);

export type StartDomainDomainMgtGetDomainStartPostError = (HTTPValidationError);

export type StartDomainDomainMgtCreateDomainStartPostData = {
    body: Body_start_domain_domain_mgt_create_domain_start_post;
};

export type StartDomainDomainMgtCreateDomainStartPostResponse = (Domain_Output);

export type StartDomainDomainMgtCreateDomainStartPostError = (HTTPValidationError);

export type StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostData = {
    body: Body_start_domain_business_entity_mgt_update_business_entity_start_post;
};

export type StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostResponse = (BusinessEntity);

export type StartDomainBusinessEntityMgtUpdateBusinessEntityStartPostError = (HTTPValidationError);

export type StartDomainBusinessEntityMgtGetBusinessEntityStartPostData = {
    body: Body_start_domain_business_entity_mgt_get_business_entity_start_post;
};

export type StartDomainBusinessEntityMgtGetBusinessEntityStartPostResponse = (BusinessEntity);

export type StartDomainBusinessEntityMgtGetBusinessEntityStartPostError = (HTTPValidationError);

export type StartDomainBusinessEntityMgtGetBusinessEntitiesByDomainStartPostData = {
    body: Body_start_domain_business_entity_mgt_get_business_entities_by_domain_start_post;
};

export type StartDomainBusinessEntityMgtGetBusinessEntitiesByDomainStartPostResponse = (Array<BusinessEntity>);

export type StartDomainBusinessEntityMgtGetBusinessEntitiesByDomainStartPostError = (HTTPValidationError);

export type StartDomainBusinessEntityMgtCreateBusinessEntityStartPostData = {
    body: Body_start_domain_business_entity_mgt_create_business_entity_start_post;
};

export type StartDomainBusinessEntityMgtCreateBusinessEntityStartPostResponse = (BusinessEntity);

export type StartDomainBusinessEntityMgtCreateBusinessEntityStartPostError = (HTTPValidationError);

export type StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostData = {
    body: Body_start_domain_business_entity_mgt_delete_business_entity_start_post;
};

export type StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostResponse = (unknown);

export type StartDomainBusinessEntityMgtDeleteBusinessEntityStartPostError = (HTTPValidationError);

export type StartDomainLabelMgtGetLabelsByDomainStartPostData = {
    body: Body_start_domain_label_mgt_get_labels_by_domain_start_post;
};

export type StartDomainLabelMgtGetLabelsByDomainStartPostResponse = (Array<Label>);

export type StartDomainLabelMgtGetLabelsByDomainStartPostError = (HTTPValidationError);

export type StartDomainLabelMgtLabelTopicStartPostData = {
    body: Body_start_domain_label_mgt_label_topic_start_post;
};

export type StartDomainLabelMgtLabelTopicStartPostResponse = (unknown);

export type StartDomainLabelMgtLabelTopicStartPostError = (HTTPValidationError);

export type StartDomainLabelMgtUnlabelTopicStartPostData = {
    body: Body_start_domain_label_mgt_unlabel_topic_start_post;
};

export type StartDomainLabelMgtUnlabelTopicStartPostResponse = (unknown);

export type StartDomainLabelMgtUnlabelTopicStartPostError = (HTTPValidationError);

export type StartDomainLabelMgtGetLabelsByTopicStartPostData = {
    body: Body_start_domain_label_mgt_get_labels_by_topic_start_post;
};

export type StartDomainLabelMgtGetLabelsByTopicStartPostResponse = (Array<Label>);

export type StartDomainLabelMgtGetLabelsByTopicStartPostError = (HTTPValidationError);

export type StartDomainLabelMgtCreateLabelStartPostData = {
    body: Body_start_domain_label_mgt_create_label_start_post;
};

export type StartDomainLabelMgtCreateLabelStartPostResponse = (unknown);

export type StartDomainLabelMgtCreateLabelStartPostError = (HTTPValidationError);

export type StartDomainRoleMgtGetRolesStartPostData = {
    body: Body_start_domain_role_mgt_get_roles_start_post;
};

export type StartDomainRoleMgtGetRolesStartPostResponse = (Array<Role>);

export type StartDomainRoleMgtGetRolesStartPostError = (HTTPValidationError);

export type StartDomainRoleMgtCreateRoleStartPostData = {
    body: Body_start_domain_role_mgt_create_role_start_post;
};

export type StartDomainRoleMgtCreateRoleStartPostResponse = (unknown);

export type StartDomainRoleMgtCreateRoleStartPostError = (HTTPValidationError);

export type StartDomainRoleMgtUpdateRoleStartPostData = {
    body: Body_start_domain_role_mgt_update_role_start_post;
};

export type StartDomainRoleMgtUpdateRoleStartPostResponse = (unknown);

export type StartDomainRoleMgtUpdateRoleStartPostError = (HTTPValidationError);

export type StartDomainRoleMgtDeleteRoleStartPostData = {
    body: Body_start_domain_role_mgt_delete_role_start_post;
};

export type StartDomainRoleMgtDeleteRoleStartPostResponse = (unknown);

export type StartDomainRoleMgtDeleteRoleStartPostError = (HTTPValidationError);

export type StartDomainRoleMgtGetRoleStartPostData = {
    body: Body_start_domain_role_mgt_get_role_start_post;
};

export type StartDomainRoleMgtGetRoleStartPostResponse = (Role);

export type StartDomainRoleMgtGetRoleStartPostError = (HTTPValidationError);

export type StartDomainTopicMgtGetTopicStartPostData = {
    body: Body_start_domain_topic_mgt_get_topic_start_post;
};

export type StartDomainTopicMgtGetTopicStartPostResponse = (Domain_Output);

export type StartDomainTopicMgtGetTopicStartPostError = (HTTPValidationError);

export type StartDomainTopicMgtUpdateTopicStartPostData = {
    body: Body_start_domain_topic_mgt_update_topic_start_post;
};

export type StartDomainTopicMgtUpdateTopicStartPostResponse = (unknown);

export type StartDomainTopicMgtUpdateTopicStartPostError = (HTTPValidationError);

export type StartDomainTopicMgtCreateReplyStartPostData = {
    body: Body_start_domain_topic_mgt_create_reply_start_post;
};

export type StartDomainTopicMgtCreateReplyStartPostResponse = (unknown);

export type StartDomainTopicMgtCreateReplyStartPostError = (HTTPValidationError);

export type StartDomainTopicMgtGetRepliesOnTopicStartPostData = {
    body: Body_start_domain_topic_mgt_get_replies_on_topic_start_post;
};

export type StartDomainTopicMgtGetRepliesOnTopicStartPostResponse = (Array<Reply>);

export type StartDomainTopicMgtGetRepliesOnTopicStartPostError = (HTTPValidationError);

export type StartDomainTopicMgtCreateTopicStartPostData = {
    body: Body_start_domain_topic_mgt_create_topic_start_post;
};

export type StartDomainTopicMgtCreateTopicStartPostResponse = (unknown);

export type StartDomainTopicMgtCreateTopicStartPostError = (HTTPValidationError);

export type StartDomainTopicMgtGetTopicsByDomainStartPostData = {
    body: Body_start_domain_topic_mgt_get_topics_by_domain_start_post;
};

export type StartDomainTopicMgtGetTopicsByDomainStartPostResponse = (Array<TopicResponse>);

export type StartDomainTopicMgtGetTopicsByDomainStartPostError = (HTTPValidationError);

export type StartProcessLaneMgtGetLaneStartPostData = {
    body: Body_start_process_lane_mgt_get_lane_start_post;
};

export type StartProcessLaneMgtGetLaneStartPostResponse = (Lane);

export type StartProcessLaneMgtGetLaneStartPostError = (HTTPValidationError);

export type StartProcessLaneMgtGetLaneByRoleIdStartPostData = {
    body: Body_start_process_lane_mgt_get_lane_by_role_id_start_post;
};

export type StartProcessLaneMgtGetLaneByRoleIdStartPostResponse = (Lane);

export type StartProcessLaneMgtGetLaneByRoleIdStartPostError = (HTTPValidationError);

export type StartProcessLaneMgtGetLaneByBpmnIdStartPostData = {
    body: Body_start_process_lane_mgt_get_lane_by_bpmn_id_start_post;
};

export type StartProcessLaneMgtGetLaneByBpmnIdStartPostResponse = (Lane);

export type StartProcessLaneMgtGetLaneByBpmnIdStartPostError = (HTTPValidationError);

export type StartProcessLaneMgtGetLanesByProcessStartPostData = {
    body: Body_start_process_lane_mgt_get_lanes_by_process_start_post;
};

export type StartProcessLaneMgtGetLanesByProcessStartPostResponse = (Array<Lane>);

export type StartProcessLaneMgtGetLanesByProcessStartPostError = (HTTPValidationError);

export type StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostData = {
    body: Body_start_process_process_element_mgt_get_process_element_by_bpmn_id_start_post;
};

export type StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostResponse = (ProcessElement);

export type StartProcessProcessElementMgtGetProcessElementByBpmnIdStartPostError = (HTTPValidationError);

export type StartProcessProcessElementMgtDeleteGatewayStartPostData = {
    body: Body_start_process_process_element_mgt_delete_gateway_start_post;
};

export type StartProcessProcessElementMgtDeleteGatewayStartPostResponse = (unknown);

export type StartProcessProcessElementMgtDeleteGatewayStartPostError = (HTTPValidationError);

export type StartProcessProcessElementMgtUpdateEventStartPostData = {
    body: Body_start_process_process_element_mgt_update_event_start_post;
};

export type StartProcessProcessElementMgtUpdateEventStartPostResponse = (unknown);

export type StartProcessProcessElementMgtUpdateEventStartPostError = (HTTPValidationError);

export type StartProcessProcessElementMgtGetProcessElementsByProcessStartPostData = {
    body: Body_start_process_process_element_mgt_get_process_elements_by_process_start_post;
};

export type StartProcessProcessElementMgtGetProcessElementsByProcessStartPostResponse = (Array<ProcessElement>);

export type StartProcessProcessElementMgtGetProcessElementsByProcessStartPostError = (HTTPValidationError);

export type StartProcessProcessElementMgtUpdateGatewayStartPostData = {
    body: Body_start_process_process_element_mgt_update_gateway_start_post;
};

export type StartProcessProcessElementMgtUpdateGatewayStartPostResponse = (unknown);

export type StartProcessProcessElementMgtUpdateGatewayStartPostError = (HTTPValidationError);

export type StartProcessProcessElementMgtGetEventStartPostData = {
    body: Body_start_process_process_element_mgt_get_event_start_post;
};

export type StartProcessProcessElementMgtGetEventStartPostResponse = (ProcessEvent);

export type StartProcessProcessElementMgtGetEventStartPostError = (HTTPValidationError);

export type StartProcessProcessElementMgtUnarchiveProcessElementStartPostData = {
    body: Body_start_process_process_element_mgt_unarchive_process_element_start_post;
};

export type StartProcessProcessElementMgtUnarchiveProcessElementStartPostResponse = (unknown);

export type StartProcessProcessElementMgtUnarchiveProcessElementStartPostError = (HTTPValidationError);

export type StartProcessProcessElementMgtDeleteEventStartPostData = {
    body: Body_start_process_process_element_mgt_delete_event_start_post;
};

export type StartProcessProcessElementMgtDeleteEventStartPostResponse = (unknown);

export type StartProcessProcessElementMgtDeleteEventStartPostError = (HTTPValidationError);

export type StartProcessProcessElementMgtArchiveProcessElementStartPostData = {
    body: Body_start_process_process_element_mgt_archive_process_element_start_post;
};

export type StartProcessProcessElementMgtArchiveProcessElementStartPostResponse = (unknown);

export type StartProcessProcessElementMgtArchiveProcessElementStartPostError = (HTTPValidationError);

export type StartProcessProcessElementMgtDeleteTaskStartPostData = {
    body: Body_start_process_process_element_mgt_delete_task_start_post;
};

export type StartProcessProcessElementMgtDeleteTaskStartPostResponse = (unknown);

export type StartProcessProcessElementMgtDeleteTaskStartPostError = (HTTPValidationError);

export type StartProcessProcessElementMgtGetTaskStartPostData = {
    body: Body_start_process_process_element_mgt_get_task_start_post;
};

export type StartProcessProcessElementMgtGetTaskStartPostResponse = (ProcessTask);

export type StartProcessProcessElementMgtGetTaskStartPostError = (HTTPValidationError);

export type StartProcessProcessElementMgtUpdateFlowStartPostData = {
    body: Body_start_process_process_element_mgt_update_flow_start_post;
};

export type StartProcessProcessElementMgtUpdateFlowStartPostResponse = (unknown);

export type StartProcessProcessElementMgtUpdateFlowStartPostError = (HTTPValidationError);

export type StartProcessProcessElementMgtGetGatewayStartPostData = {
    body: Body_start_process_process_element_mgt_get_gateway_start_post;
};

export type StartProcessProcessElementMgtGetGatewayStartPostResponse = (ProcessGateway);

export type StartProcessProcessElementMgtGetGatewayStartPostError = (HTTPValidationError);

export type StartProcessProcessElementMgtUpdateTaskStartPostData = {
    body: Body_start_process_process_element_mgt_update_task_start_post;
};

export type StartProcessProcessElementMgtUpdateTaskStartPostResponse = (unknown);

export type StartProcessProcessElementMgtUpdateTaskStartPostError = (HTTPValidationError);

export type StartProcessProcessElementMgtGetFlowStartPostData = {
    body: Body_start_process_process_element_mgt_get_flow_start_post;
};

export type StartProcessProcessElementMgtGetFlowStartPostResponse = (ProcessFlow);

export type StartProcessProcessElementMgtGetFlowStartPostError = (HTTPValidationError);

export type StartProcessProcessElementMgtDeleteFlowStartPostData = {
    body: Body_start_process_process_element_mgt_delete_flow_start_post;
};

export type StartProcessProcessElementMgtDeleteFlowStartPostResponse = (unknown);

export type StartProcessProcessElementMgtDeleteFlowStartPostError = (HTTPValidationError);

export type StartProcessProcessMgtGetProcessStartPostData = {
    body: Body_start_process_process_mgt_get_process_start_post;
};

export type StartProcessProcessMgtGetProcessStartPostResponse = (Process);

export type StartProcessProcessMgtGetProcessStartPostError = (HTTPValidationError);

export type StartProcessProcessMgtMoveProcessStartPostData = {
    body: Body_start_process_process_mgt_move_process_start_post;
};

export type StartProcessProcessMgtMoveProcessStartPostResponse = (unknown);

export type StartProcessProcessMgtMoveProcessStartPostError = (HTTPValidationError);

export type StartProcessProcessMgtGenerateDefinitionStartPostData = {
    body: Body_start_process_process_mgt_generate_definition_start_post;
};

export type StartProcessProcessMgtGenerateDefinitionStartPostResponse = (Array<(CreateTask | CreateGateway | CreateConnection)>);

export type StartProcessProcessMgtGenerateDefinitionStartPostError = (HTTPValidationError);

export type StartProcessProcessMgtDeployProcessStartPostData = {
    body: Body_start_process_process_mgt_deploy_process_start_post;
};

export type StartProcessProcessMgtDeployProcessStartPostResponse = ({
    [key: string]: unknown;
});

export type StartProcessProcessMgtDeployProcessStartPostError = (HTTPValidationError);

export type StartProcessProcessMgtUpdateProcessStartPostData = {
    body: Body_start_process_process_mgt_update_process_start_post;
};

export type StartProcessProcessMgtUpdateProcessStartPostResponse = (unknown);

export type StartProcessProcessMgtUpdateProcessStartPostError = (HTTPValidationError);

export type StartProcessProcessMgtDeleteProcessStartPostData = {
    body: Body_start_process_process_mgt_delete_process_start_post;
};

export type StartProcessProcessMgtDeleteProcessStartPostResponse = (unknown);

export type StartProcessProcessMgtDeleteProcessStartPostError = (HTTPValidationError);

export type StartProcessProcessMgtCreateProcessStartPostData = {
    body: Body_start_process_process_mgt_create_process_start_post;
};

export type StartProcessProcessMgtCreateProcessStartPostResponse = (Process);

export type StartProcessProcessMgtCreateProcessStartPostError = (HTTPValidationError);

export type StartProcessProcessMgtGetProcessesByProductStartPostData = {
    body: Body_start_process_process_mgt_get_processes_by_product_start_post;
};

export type StartProcessProcessMgtGetProcessesByProductStartPostResponse = (Array<Process>);

export type StartProcessProcessMgtGetProcessesByProductStartPostError = (HTTPValidationError);

export type GetUsersUserGetResponse = (Array<User>);

export type GetUsersUserGetError = unknown;

export type CreateUserUserPostData = {
    body: CreateUser;
};

export type CreateUserUserPostResponse = (User);

export type CreateUserUserPostError = (HTTPValidationError);

export type DeleteUserUserUserIdDeleteData = {
    path: {
        user_id: string;
    };
};

export type DeleteUserUserUserIdDeleteResponse = (unknown);

export type DeleteUserUserUserIdDeleteError = (HTTPValidationError);

export type GetSelfUserMeGetResponse = (User);

export type GetSelfUserMeGetError = unknown;

export type GetDomainRolesUserUserIdDomainRolesGetData = {
    path: {
        user_id: string;
    };
};

export type GetDomainRolesUserUserIdDomainRolesGetResponse = (Array<DomainRole>);

export type GetDomainRolesUserUserIdDomainRolesGetError = (HTTPValidationError);

export type MakeUserManagerUserUserIdMakeUserManagerPostData = {
    path: {
        user_id: string;
    };
};

export type MakeUserManagerUserUserIdMakeUserManagerPostResponse = (unknown);

export type MakeUserManagerUserUserIdMakeUserManagerPostError = (HTTPValidationError);

export type MakeUserUserUserIdMakeUserPostData = {
    path: {
        user_id: string;
    };
};

export type MakeUserUserUserIdMakeUserPostResponse = (unknown);

export type MakeUserUserUserIdMakeUserPostError = (HTTPValidationError);

export type PreviewLinkProxyPreviewLinkGetData = {
    query: {
        url: string;
    };
};

export type PreviewLinkProxyPreviewLinkGetResponse = (LinkPreview);

export type PreviewLinkProxyPreviewLinkGetError = (HTTPValidationError);